import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "File glob specification",
  "description": "Learn about the file glob specification used by `turbo`."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "File globs are used throughout Turborepo for configuring which files to include or exclude in various contexts, allowing you to specifically define the files you want turbo to use."
  }, {
    "heading": "glob-patterns",
    "content": "Pattern"
  }, {
    "heading": "glob-patterns",
    "content": "Description"
  }, {
    "heading": "glob-patterns",
    "content": "*"
  }, {
    "heading": "glob-patterns",
    "content": "Match all files in the directory"
  }, {
    "heading": "glob-patterns",
    "content": "**"
  }, {
    "heading": "glob-patterns",
    "content": "Recursively match all files and sub-directories"
  }, {
    "heading": "glob-patterns",
    "content": "some-dir/"
  }, {
    "heading": "glob-patterns",
    "content": "Match the some-dir directory and its contents"
  }, {
    "heading": "glob-patterns",
    "content": "some-dir"
  }, {
    "heading": "glob-patterns",
    "content": "Match a file named some-dir or a some-dir directory and its contents"
  }, {
    "heading": "glob-patterns",
    "content": "some-dir*"
  }, {
    "heading": "glob-patterns",
    "content": "Match files and directories that start with some-dir, including contents when matching a directory"
  }, {
    "heading": "glob-patterns",
    "content": "*.js"
  }, {
    "heading": "glob-patterns",
    "content": "Match all .js files in the directory"
  }, {
    "heading": "glob-patterns",
    "content": "!"
  }, {
    "heading": "glob-patterns",
    "content": "Negate the whole glob (automatically applies /** to the end of the defined glob)"
  }, {
    "heading": "examples",
    "content": "Pattern"
  }, {
    "heading": "examples",
    "content": "Description"
  }, {
    "heading": "examples",
    "content": "dist/**"
  }, {
    "heading": "examples",
    "content": "Match all files in the dist directory, its contents, and all sub-directories"
  }, {
    "heading": "examples",
    "content": "dist/"
  }, {
    "heading": "examples",
    "content": "Match the dist directory and its contents"
  }, {
    "heading": "examples",
    "content": "dist"
  }, {
    "heading": "examples",
    "content": "Match a file named dist or a dist directory, its contents, and all sub-directories"
  }, {
    "heading": "examples",
    "content": "dist/some-dir/**"
  }, {
    "heading": "examples",
    "content": "Match all files in the dist/some-dir directory and all sub-directories in the current directory"
  }, {
    "heading": "examples",
    "content": "!dist"
  }, {
    "heading": "examples",
    "content": "Ignore the dist directory and all of its contents"
  }, {
    "heading": "examples",
    "content": "dist*"
  }, {
    "heading": "examples",
    "content": "Match files and directories that start with dist"
  }, {
    "heading": "examples",
    "content": "dist/*.js"
  }, {
    "heading": "examples",
    "content": "Match all .js files in the dist directory"
  }, {
    "heading": "examples",
    "content": "!dist/*.js"
  }, {
    "heading": "examples",
    "content": "Ignore all .js files in the dist directory"
  }, {
    "heading": "examples",
    "content": "dist/**/*.js"
  }, {
    "heading": "examples",
    "content": "Recursively match all .js files in the dist directory and its sub-directories"
  }, {
    "heading": "examples",
    "content": "../scripts/**"
  }, {
    "heading": "examples",
    "content": "Up one directory, match all files and sub-directories in the scripts directory"
  }],
  "headings": [{
    "id": "glob-patterns",
    "content": "Glob patterns"
  }, {
    "id": "examples",
    "content": "Examples"
  }]
};
export const toc = [{
  depth: 2,
  url: "#glob-patterns",
  title: _jsx(_Fragment, {
    children: "Glob patterns"
  })
}, {
  depth: 2,
  url: "#examples",
  title: _jsx(_Fragment, {
    children: "Examples"
  })
}];
function _createMdxContent(props) {
  const _components = {
    code: "code",
    h2: "h2",
    p: "p",
    table: "table",
    tbody: "tbody",
    td: "td",
    th: "th",
    thead: "thead",
    tr: "tr",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsxs(_components.p, {
      children: ["File globs are used throughout Turborepo for configuring which files to include or exclude in various contexts, allowing you to specifically define the files you want ", _jsx(_components.code, {
        children: "turbo"
      }), " to use."]
    }), "\n", _jsx(_components.h2, {
      id: "glob-patterns",
      children: "Glob patterns"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Pattern"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*"
            })
          }), _jsx(_components.td, {
            children: "Match all files in the directory"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "**"
            })
          }), _jsx(_components.td, {
            children: "Recursively match all files and sub-directories"
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir/"
            })
          }), _jsxs(_components.td, {
            children: ["Match the ", _jsx(_components.code, {
              children: "some-dir"
            }), " directory and its contents"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir"
            })
          }), _jsxs(_components.td, {
            children: ["Match a file named ", _jsx(_components.code, {
              children: "some-dir"
            }), " or a ", _jsx(_components.code, {
              children: "some-dir"
            }), " directory and its contents"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "some-dir*"
            })
          }), _jsxs(_components.td, {
            children: ["Match files and directories that start with ", _jsx(_components.code, {
              children: "some-dir"
            }), ", including contents when matching a directory"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "*.js"
            })
          }), _jsxs(_components.td, {
            children: ["Match all ", _jsx(_components.code, {
              children: ".js"
            }), " files in the directory"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!"
            })
          }), _jsxs(_components.td, {
            children: ["Negate the whole glob (automatically applies ", _jsx(_components.code, {
              children: "/**"
            }), " to the end of the defined glob)"]
          })]
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "examples",
      children: "Examples"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Pattern"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**"
            })
          }), _jsxs(_components.td, {
            children: ["Match all files in the ", _jsx(_components.code, {
              children: "dist"
            }), " directory, its contents, and all sub-directories"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/"
            })
          }), _jsxs(_components.td, {
            children: ["Match the ", _jsx(_components.code, {
              children: "dist"
            }), " directory and its contents"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist"
            })
          }), _jsxs(_components.td, {
            children: ["Match a file named ", _jsx(_components.code, {
              children: "dist"
            }), " or a ", _jsx(_components.code, {
              children: "dist"
            }), " directory, its contents, and all sub-directories"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/some-dir/**"
            })
          }), _jsxs(_components.td, {
            children: ["Match all files in the ", _jsx(_components.code, {
              children: "dist/some-dir"
            }), " directory and all sub-directories in the current directory"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist"
            })
          }), _jsxs(_components.td, {
            children: ["Ignore the ", _jsx(_components.code, {
              children: "dist"
            }), " directory and all of its contents"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist*"
            })
          }), _jsxs(_components.td, {
            children: ["Match files and directories that start with ", _jsx(_components.code, {
              children: "dist"
            })]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["Match all ", _jsx(_components.code, {
              children: ".js"
            }), " files in the ", _jsx(_components.code, {
              children: "dist"
            }), " directory"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "!dist/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["Ignore all ", _jsx(_components.code, {
              children: ".js"
            }), " files in the ", _jsx(_components.code, {
              children: "dist"
            }), " directory"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "dist/**/*.js"
            })
          }), _jsxs(_components.td, {
            children: ["Recursively match all ", _jsx(_components.code, {
              children: ".js"
            }), " files in the ", _jsx(_components.code, {
              children: "dist"
            }), " directory and its sub-directories"]
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: _jsx(_components.code, {
              children: "../scripts/**"
            })
          }), _jsxs(_components.td, {
            children: ["Up one directory, match all files and sub-directories in the ", _jsx(_components.code, {
              children: "scripts"
            }), " directory"]
          })]
        })]
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
